import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class ZonasService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/zonas/'
    }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/xpress-dev/src/app/shared/services/api/zonas.service.ts